module.exports = __webpack_public_path__ + "static/dots-red-texture-f2b36ac60dd5ea78fcfe8db8b56256b0.svg";